import palette from './palette';

const token = {
  // -- seed token
  borderRadius: 4,
  colorBgBase: palette.acastGreyLighter,
  colorError: palette.acastRed,
  colorInfo: palette.acastPurple,
  colorLink: palette.acastBlueAccent,
  colorPrimary: palette.acastPurple,
  colorSuccess: palette.acastGreen,
  colorTextBase: palette.acastBlackDefault,
  colorWarning: palette.acastOrange,
  controlHeight: 32,
  fontFamily:
    "'IBM-Plex-Sans-Regular', -apple-system, BlinkMacSystemFont, Helvetica, Arial, sans-serif",
  fontFamilyCode: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace",
  fontSize: 14,
  lineType: 'solid',
  lineWidth: 1,
  motion: true,
  motionBase: 0,
  motionEaseInBack: 'cubic-bezier(0.71, -0.46, 0.88, 0.6)',
  motionEaseInOut: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
  motionEaseInOutCirc: 'cubic-bezier(0.78, 0.14, 0.15, 0.86)',
  motionEaseInQuint: 'cubic-bezier(0.755, 0.05, 0.855, 0.06)',
  motionEaseOut: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
  motionEaseOutBack: 'cubic-bezier(0.12, 0.4, 0.29, 1.46)',
  motionEaseOutCirc: 'cubic-bezier(0.08, 0.82, 0.17, 1)',
  motionEaseOutQuint: 'cubic-bezier(0.23, 1, 0.32, 1)',
  motionUnit: 0.1,
  opacityImage: 0,
  sizePopupArrow: 16,
  sizeStep: 4,
  sizeUnit: 4,
  wireframe: false,
  zIndexBase: 0,
  zIndexPopupBase: 1000,

  // -- map token
  borderRadiusLG: 4,
  borderRadiusOuter: 4,
  borderRadiusSM: 4,
  borderRadiusXS: 2,
  colorBgBlur: 'transparent',
  colorBgContainer: palette.white,
  colorBgElevated: palette.white,
  colorBgLayout: palette.acastGreyLighter,
  colorBgMask: 'rgba(0, 0, 0, 0.45)',
  colorBgSolid: 'rgb(0, 0, 0)',
  colorBgSolidActive: 'rgba(0, 0, 0, 0.95)',
  colorBgSolidHover: 'rgba(0, 0, 0, 0.75)',
  colorBgSpotlight: 'rgba(0, 0, 0, 0.85)',
  colorBorder: palette.acastPurpleLight,
  colorBorderSecondary: palette.acastGreyLight,
  colorErrorActive: palette.acastRedHover,
  colorErrorBg: palette.acastRedLight,
  colorErrorBgActive: palette.acastRedMid,
  colorErrorBgFilledHover: palette.acastRedLight,
  colorErrorBgHover: palette.acastRedLight,
  colorErrorBorder: palette.acastRedLight,
  colorErrorBorderHover: palette.acastRedHover,
  colorErrorHover: palette.acastRedHover,
  colorErrorText: palette.acastRed,
  colorErrorTextActive: palette.acastRedHover,
  colorErrorTextHover: palette.acastRedHover,
  colorFill: 'rgba(0, 0, 0, 0.15)',
  colorFillQuaternary: 'rgba(0, 0, 0, 0.02)',
  colorFillSecondary: 'rgba(0, 0, 0, 0.06)',
  colorFillTertiary: 'rgba(0, 0, 0, 0.04)',
  colorInfoActive: palette.acastBlueDarker,
  colorInfoBg: palette.white,
  colorInfoBgHover: palette.acastPurpleGreyAccent,
  colorInfoBorder: palette.acastPurpleGreyAccent,
  colorInfoBorderHover: palette.acastPurpleGreyAccent,
  colorInfoHover: palette.acastPurpleGreyAccent,
  colorInfoText: palette.acastPurple,
  colorInfoTextActive: palette.acastBlueDarker,
  colorInfoTextHover: palette.acastBlueAccent,
  colorLinkActive: palette.acastBlueDarker,
  colorLinkHover: palette.acastBlueAccent,
  colorPrimaryActive: palette.acastPurpleActive,
  colorPrimaryBg: palette.acastPurpleLight,
  colorPrimaryBgHover: palette.acastPurpleLight,
  colorPrimaryBorder: palette.acastPurpleMid,
  colorPrimaryBorderHover: palette.acastPurpleMid,
  colorPrimaryHover: palette.acastPurpleHover,
  colorPrimaryText: palette.acastBlackDefault,
  colorPrimaryTextActive: palette.acastBlackDefault,
  colorPrimaryTextHover: palette.acastBlackDefault,
  colorSuccessActive: palette.acastGreenDark,
  colorSuccessBg: palette.acastGreenMid,
  colorSuccessBgHover: palette.acastGreenLight,
  colorSuccessBorder: palette.acastGreen,
  colorSuccessBorderHover: palette.acastGreenLight,
  colorSuccessHover: palette.acastGreenLight,
  colorSuccessText: palette.acastGreen,
  colorSuccessTextActive: palette.acastGreenDark,
  colorSuccessTextHover: palette.acastGreenDark,
  colorText: palette.acastBlackDefault,
  colorTextQuaternary: 'rgba(0, 0, 0, 0.25)',
  colorTextSecondary: 'rgba(0, 0, 0, 0.65)',
  colorTextTertiary: 'rgba(0, 0, 0, 0.45)',
  colorWarningActive: palette.acastOrangeAccent,
  colorWarningBg: palette.acastOrangeLight,
  colorWarningBgHover: palette.acastOrangeLight,
  colorWarningBorder: palette.acastOrangeLight,
  colorWarningBorderHover: palette.acastOrangeAccent,
  colorWarningHover: palette.acastOrangeAccent,
  colorWarningText: palette.acastOrangeAccent,
  colorWarningTextActive: palette.acastOrangeAccent,
  colorWarningTextHover: palette.acastOrangeAccent,
  colorWhite: palette.white,
  controlHeightLG: 40,
  controlHeightSM: 24,
  controlHeightXS: 16,
  fontSizeHeading1: 38,
  fontSizeHeading2: 30,
  fontSizeHeading3: 24,
  fontSizeHeading4: 20,
  fontSizeHeading5: 16,
  fontSizeLG: 16,
  fontSizeSM: 12,
  fontSizeXL: 20,
  lineHeight: 1.5714285714285714,
  lineHeightHeading1: 1.2105263157894737,
  lineHeightHeading2: 1.2666666666666666,
  lineHeightHeading3: 1.3333333333333333,
  lineHeightHeading4: 1.4,
  lineHeightHeading5: 1.5,
  lineHeightLG: 1.5,
  lineHeightSM: 1.6666666666666667,
  lineWidthBold: 2,
  motionDurationFast: '0.1s',
  motionDurationMid: '0.2s',
  motionDurationSlow: '0.3s',
  size: 16,
  sizeLG: 24,
  sizeMD: 20,
  sizeMS: 16,
  sizeSM: 12,
  sizeXL: 32,
  sizeXS: 8,
  sizeXXL: 48,
  sizeXXS: 4,

  // -- alias

  boxShadow:
    '0px 0px 12px rgba(41, 41, 107, 0.06), 0px 0px 6px rgba(41, 41, 107, 0.06), 0px 0px 3px rgba(41, 41, 107, 0.06)',
  boxShadowSecondary:
    '0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05)',
  boxShadowTertiary:
    '0 1px 2px 0 rgba(0, 0, 0, 0.03), 0 1px 6px -1px rgba(0, 0, 0, 0.02), 0 2px 4px 0 rgba(0, 0, 0, 0.02)',
  colorBgContainerDisabled: 'rgba(0, 0, 0, 0.04)',
  colorBgTextActive: 'rgba(0, 0, 0, 0.15)',
  colorBgTextHover: 'rgba(0, 0, 0, 0.06)',
  colorBorderBg: palette.white,
  colorErrorOutline: 'rgba(255, 38, 5, 0.06)',
  colorFillAlter: 'rgba(0, 0, 0, 0.02)',
  colorFillContent: 'rgba(0, 0, 0, 0.06)',
  colorFillContentHover: 'rgba(0, 0, 0, 0.15)',
  colorHighlight: palette.acastRed,
  colorIcon: 'rgba(0, 0, 0, 0.45)',
  colorIconHover: 'rgba(0, 0, 0, 0.88)',
  colorSplit: 'rgba(5, 5, 5, 0.06)',
  colorTextDescription: palette.acastBlackDefault,
  colorTextDisabled: 'rgba(0, 0, 0, 0.25)',
  colorTextHeading: palette.acastBlackDefault,
  colorTextLabel: palette.acastBlackDefault,
  colorTextLightSolid: palette.white,
  colorTextPlaceholder: 'rgba(0, 0, 0, 0.25)',
  colorWarningOutline: 'rgba(255, 215, 5, 0.1)',
  controlInteractiveSize: 16,
  controlItemBgActive: palette.acastPurpleLight,
  controlItemBgActiveDisabled: 'rgba(0, 0, 0, 0.15)',
  controlItemBgActiveHover: palette.acastPurpleLight,
  controlItemBgHover: 'rgba(0, 0, 0, 0.04)',
  controlOutline: 'rgba(5, 145, 255, 0.1)',
  controlOutlineWidth: 2,
  controlPaddingHorizontal: 12,
  controlPaddingHorizontalSM: 8,
  fontSizeIcon: 12,
  fontWeightStrong: 600,
  lineWidthFocus: 3,
  linkDecoration: 'none',
  linkFocusDecoration: 'none',
  linkHoverDecoration: 'none',
  margin: 16,
  marginLG: 24,
  marginMD: 20,
  marginSM: 12,
  marginXL: 32,
  marginXS: 8,
  marginXXL: 48,
  marginXXS: 4,
  opacityLoading: 0.65,
  padding: 16,
  paddingContentHorizontal: 16,
  paddingContentHorizontalLG: 24,
  paddingContentHorizontalSM: 16,
  paddingContentVertical: 12,
  paddingContentVerticalLG: 16,
  paddingContentVerticalSM: 8,
  paddingLG: 24,
  paddingMD: 20,
  paddingSM: 12,
  paddingXL: 32,
  paddingXS: 8,
  paddingXXS: 4,
  screenLG: 992,
  screenLGMax: 1199,
  screenLGMin: 992,
  screenMD: 768,
  screenMDMax: 991,
  screenMDMin: 768,
  screenSM: 576,
  screenSMMax: 767,
  screenSMMin: 576,
  screenXL: 1200,
  screenXLMax: 1599,
  screenXLMin: 1200,
  screenXS: 480,
  screenXSMin: 480,
  screenXSMax: 575,
  screenXXL: 1600,
  screenXXLMin: 1600,
  acastPalette: palette,
};

const components = {
  Alert: {
    colorInfoBorder: palette.acastPurpleFocus,
    colorInfoBg: palette.acastPurpleRadio,
    colorInfo: palette.acastPurpleFocus,
    colorWarningBorder: palette.acastOrangeAccent,
    colorWarningBg: palette.acastOrangeLight,
    colorWarning: palette.acastOrangeAccent,
    colorErrorBorder: palette.acastRedMid,
    colorErrorBg: palette.acastRedLight,
    colorError: palette.acastRed,
  },
  Breadcrumb: {
    fontSize: 18,
    colorBgTextHover: 'rgba(0, 0, 0, 0)',
  },
  Button: {
    colorText: palette.acastBlackDefault,
    colorBgContainer: palette.white,
    colorBorder: palette.acastPurpleMid,
    defaultHoverBg: palette.acastPurpleLight,
    primaryColor: palette.white,
    colorPrimary: palette.acastPurple,
    colorTextDisabled: palette.acastGreyAccent,
    colorBgContainerDisabled: palette.acastGreyLighter,
    borderColorDisabled: palette.acastGreyActive,
    defaultGhostColor: palette.acastBlackDefault,
    ghostBg: palette.white,
    defaultGhostBorderColor: palette.acastGreyAccent,
    colorError: palette.acastRed,
    colorErrorBorder: palette.acastRedMid,
  },
  Card: {
    colorBgContainer: palette.white,
    headerBg: palette.white,
    borderRadiusLG: 4,
  },
  Collapse: {
    headerBg: palette.white,
  },
  Input: {
    colorBgContainer: palette.white,
    colorText: palette.acastBlackDefault,
    colorTextPlaceholder: palette.acastGreyAccent,
  },
  Menu: {
    itemSelectedColor: palette.acastPurple,
    itemBorderRadius: 0,
    itemMarginInline: 0,
    subMenuItemBorderRadius: 0,
  },
  Message: {
    borderRadiusLG: 4,
  },
  Modal: {
    contentBg: palette.acastGreyLighter,
    headerBg: palette.acastGreyLighter,
  },
  Radio: {
    buttonCheckedBg: palette.acastPurpleRadio,
  },
  Select: {
    selectorBg: palette.white,
    colorBgElevated: palette.white,
    optionSelectedColor: palette.acastBlackDefault,
    optionSelectedBg: palette.acastPurpleGreyAccent,
    optionActiveBg: palette.acastPurpleGrey,
  },
  Steps: {
    stepsFinishIconBgColor: palette.acastGreen,
  },
  Table: {
    colorBgContainer: palette.white,
    headerBg: palette.white,
    headerColor: palette.acastGreyAccent,
    bodySortActiveBg: palette.acastPurpleGreyAccent,
    bodySortBg: palette.white,
    rowHoverBg: palette.acastPurpleGrey,
  },
  Tabs: {
    itemSelectedColor: palette.acastPurple,
    inkBarColor: palette.acastPurple,
    highlightColor: palette.acastPurple,
    horizontalItemGutter: 0,
    horizontalItemMargin: 20,
  },
  Tag: {
    defaultBg: palette.acastPurple,
    defaultColor: palette.acastYellowLight,
  },
};

const theme = { token, components };

export default theme;
